<!--
  更多
  lovi 2020-06-15
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('common.all')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    >
      <span slot="right" v-if="editFlag" class="text-blue" @click="complete">
        {{ $t("common.done") }}
      </span>
    </van-nav-bar>
    <div class="scroll-wrapper">
      <div class="column-menu my-menu" v-if="!editFlag">
        <div class="info">
          <span>{{ $t("onlinePay.myApps") }}</span>
          <img
            v-for="(item, index) in homeList"
            :key="index"
            :src="httpUrl + item.icon"
          />
        </div>
        <van-button type="default" size="mini" @click="editFlag = true">
          {{ $t("common.edit") }}
        </van-button>
      </div>
      <div class="column-menu" v-else>
        <div class="title">
          <h3>{{ $t("onlinePay.myApps") }}</h3>
          <span class="text-gray">{{ $t("onlinePay.dragTips") }}</span>
        </div>
        <div class="entrance">
          <div
            class="item"
            v-for="(item, index) in homeList"
            :key="index"
            v-dragging="{ item: item, list: homeList, group: 'item' }"
          >
            <i class="minus" @click.stop="changeApps(1, item, index)"></i>
            <div class="image"><img :src="httpUrl + item.icon" /></div>
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>

      <div class="column-menu" v-for="(item, index) in newList" :key="index">
        <div class="title">
          <h3>{{ item.class_name }}</h3>
        </div>
        <div class="entrance">
          <div
            class="item"
            v-for="(item2, index2) in item.class_info"
            :key="index2"
            @click="clickEntrance(item2.key)"
          >
            <i
              v-if="editFlag"
              class="plus"
              @click.stop="changeApps(2, item2)"
            ></i>
            <div class="image"><img :src="httpUrl + item2.icon" /></div>
            <p>{{ item2.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "allApps",
  meta: {
    power: false,
    service: false
  },
  components: {},
  data() {
    return {
      editFlag: false,
      homeList: [],
      newList: []
    };
  },
  created() {
    this._getHomeData();
  },
  mounted() {
    this.$dragging.$on("dragged", ({ value }) => {
      console.log("value", value);
    });
  },
  computed: {},
  methods: {
    clickEntrance(key) {
      // 入口
      let vm = this;
      if (key == 21) {
        vm._linkFun("/combo");
      } else if (key == 22) {
        vm._linkFun("/batch");
      } else if (key == 23) {
        vm._linkFun("/single");
      } else {
        vm._linkFun("/onlinePay?flag=" + key);
      }
    },
    _getHomeData() {
      // 获取首页数据
      let vm = this;
      vm.$post("/app/index/index", {}, { loading: true }).then(res => {
        console.log("home", res);
        vm.homeData = res;
        let moreIcon = res.icon.icon;
        vm.homeList = res.icon.icon_index;
        console.log("homeList", vm.homeList);
        vm.newList = JSON.parse(JSON.stringify(moreIcon));
        vm.initialize(vm.homeList);
      });
    },
    initialize(arr) {
      // 删除本地数据
      console.log("initialize", arr);
      let vm = this;
      let del = [];
      for (let i = 0; i < arr.length; i++) {
        let index = arr[i].class - 1;
        for (let j = 0; j < vm.newList.length; j++) {
          for (let k = 0; k < vm.newList[j].class_info.length; k++) {
            if (index == j) {
              if (arr[i].id == vm.newList[j].class_info[k].id) {
                del.push(vm.newList[j].class_info[k]);
                vm.newList[j].class_info.splice(k, 1);
              }
            }
          }
        }
      }
      console.log("del", del);
    },
    changeApps(flag, data, index) {
      // 修改APP
      let vm = this;
      console.log(flag, data);
      let cur = data.class - 1;
      if (flag == 1) {
        // 删除
        vm.homeList.splice(index, 1);
        let newData = vm.newList[cur].class_info;
        newData.push(data);
        newData.sort((a, b) => a.sort - b.sort);
        vm.newList[cur].class_info = newData;
      }
      if (flag == 2) {
        // 添加
        for (let i = 0; i < vm.newList[cur].class_info.length; i++) {
          if (data.id == vm.newList[cur].class_info[i].id) {
            if (vm.homeList.length > 6) {
              vm.$toast(vm.$t("onlinePay.dragTips"));
              return false;
            }
            vm.homeList.push(vm.newList[cur].class_info[i]);
            vm.newList[cur].class_info.splice(i, 1);
          }
        }
      }
    },
    complete() {
      // 完成
      let vm = this;
      let list = JSON.parse(JSON.stringify(this.homeList));
      let newList = [];
      for (let key of list) {
        newList.push(key.id);
      }
      let params = {};
      params.info = newList.join();
      vm.$post("/app/index/iconEdit", params, {
        loading: true
      }).then(res => {
        console.log("iconEdit", res);
        this.editFlag = false;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.column-menu {
  padding: 10px;
  background: #fff;
  font-size: 14px;
  line-height: 1.2;
  border-bottom: 12px solid #eee;
  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    h3 {
      font-weight: 400;
      font-size: 14px;
    }
    span {
      margin-left: 10px;
      font-size: 12px;
    }
  }
}

.my-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .info {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      margin-left: 4px;
      height: 22px;
    }
  }
  /deep/.van-button--default {
    color: #2042ab;
    border: 1.1px solid #2042ab;
  }
}

.entrance {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .item {
    position: relative;
    padding: 5px;
    width: 25%;
    display: flex;
    flex-direction: column;
    text-align: center;
    transition: all 0.5s;
    &.dragging {
      transform: scale(1.1);
      opacity: 0.9;
    }
    .minus,
    .plus {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 14px;
      height: 14px;
      background-size: 100%;
    }
    .minus {
      background-image: url("@{images}public/icon_minus@2x.png");
    }
    .plus {
      background-image: url("@{images}public/icon_plus@2x.png");
    }
    .image {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 44px;
      overflow: hidden;
      img {
        max-width: 100%;
        max-height: 44px;
      }
    }
    p {
      width: 100%;
      padding-top: 5px;
      line-height: 1.2;
      font-size: 12px;
    }
  }
}
</style>
